import DescriptionStep from '@/profile-creation-wizard/components/for-completion/ui/5_description/DescriptionStep.vue';
import RecommendationStep from '@/profile-creation-wizard/components/for-completion/ui/6_recommendation/RecommendationStep.vue';
import PrivacyStep from '@/profile-creation-wizard/components/for-completion/ui/7_privacy/PrivacyStep.vue';
import HeadlineStep from '@/profile-creation-wizard/components/for-creation/ui/1_headline/HeadlineStep.vue';
import CategorizationStep from '@/profile-creation-wizard/components/for-creation/ui/2_categorization/CategorizationStep.vue';
import MaltClassicExpertiseStep from '@/profile-creation-wizard/components/for-creation/ui/3_expertise/MaltClassicExpertiseStep.vue';
import LocalisationDetails from '@/profile-creation-wizard/components/for-creation/ui/4_localisation/LocalisationStep.vue';
import DailyRateStep from '@/profile-creation-wizard/components/for-creation/ui/dailyRate/DailyRateStep.vue';
import IndustryExpertiseStep from '@/profile-creation-wizard/components/for-creation/ui/industrySkills/IndustryExpertiseStep.vue';
import {ProfileCreationStepGroup, ProfileCreationSteps} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';

export enum MaltClassicCreationStepNumber {
    SIGNUP_HEADLINE = 1,
    SIGNUP_CATEGORIZATION = 2,
    SIGNUP_EXPERTISE = 3,
    SIGNUP_INDUSTRY_EXPERTISE = 4,
    SIGNUP_DAILY_RATE = 5,
    SIGNUP_LOCALISATION = 6,
    COMPLETION_DESCRIPTION = 7,
    COMPLETION_RECOMMENDATION = 8,
    COMPLETION_PRIVACY = 9,
}

export enum MaltClassicCreationStepPercentage {
    SIGNUP_HEADLINE = 5,
    SIGNUP_CATEGORIZATION = 50,
    SIGNUP_EXPERTISE = 50,
    SIGNUP_INDUSTRY_EXPERTISE = 50,
    SIGNUP_DAILY_RATE = 50,
    SIGNUP_LOCALISATION = 50,
    COMPLETION_DESCRIPTION = 50,
    COMPLETION_RECOMMENDATION = 50,
    COMPLETION_PRIVACY = 95,
}

export enum MaltClassicCreationStepName {
    SIGNUP_HEADLINE = 'signup_headline',
    SIGNUP_CATEGORIZATION = 'signup_categorization',
    SIGNUP_EXPERTISE = 'signup_expertise',
    SIGNUP_INDUSTRY_EXPERTISE = 'signup_industry_expertise',
    SIGNUP_DAILY_RATE = 'signup_daily_rate',
    SIGNUP_LOCALISATION = 'signup_localisation',
    COMPLETION_DESCRIPTION = 'completion_description',
    COMPLETION_RECOMMENDATION = 'completion_recommendation',
    COMPLETION_PRIVACY = 'completion_privacy',
}

export enum MaltClassicCreationStepRoute {
    SIGNUP_HEADLINE = '/signup/headline',
    SIGNUP_CATEGORIZATION = '/signup/categorization',
    SIGNUP_EXPERTISE = '/signup/expertise',
    SIGNUP_INDUSTRY_EXPERTISE = '/signup/industry-expertise',
    SIGNUP_DAILY_RATE = '/signup/daily-rate',
    SIGNUP_LOCALISATION = '/signup/localisation',
    COMPLETION_DESCRIPTION = '/completion/description',
    COMPLETION_RECOMMENDATION = '/completion/recommendation',
    COMPLETION_PRIVACY = '/completion/privacy',
}

const totalStep = 9;

export const maltClassicCreationSteps: ProfileCreationSteps = [
    {
        name: MaltClassicCreationStepName.SIGNUP_HEADLINE,
        route: MaltClassicCreationStepRoute.SIGNUP_HEADLINE,
        stepNumber: MaltClassicCreationStepNumber.SIGNUP_HEADLINE,
        stepCount: totalStep,
        stepPercentage: MaltClassicCreationStepPercentage.SIGNUP_HEADLINE,
        previousStepName: null,
        nextStepName: MaltClassicCreationStepName.SIGNUP_CATEGORIZATION,
        group: ProfileCreationStepGroup.SIGNUP,
        component: HeadlineStep,
    },
    {
        name: MaltClassicCreationStepName.SIGNUP_CATEGORIZATION,
        route: MaltClassicCreationStepRoute.SIGNUP_CATEGORIZATION,
        stepNumber: MaltClassicCreationStepNumber.SIGNUP_CATEGORIZATION,
        stepCount: totalStep,
        stepPercentage: MaltClassicCreationStepPercentage.SIGNUP_CATEGORIZATION,
        previousStepName: MaltClassicCreationStepName.SIGNUP_HEADLINE,
        nextStepName: MaltClassicCreationStepName.SIGNUP_EXPERTISE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: CategorizationStep,
    },
    {
        name: MaltClassicCreationStepName.SIGNUP_EXPERTISE,
        route: MaltClassicCreationStepRoute.SIGNUP_EXPERTISE,
        stepNumber: MaltClassicCreationStepNumber.SIGNUP_EXPERTISE,
        stepCount: totalStep,
        stepPercentage: MaltClassicCreationStepPercentage.SIGNUP_EXPERTISE,
        previousStepName: MaltClassicCreationStepName.SIGNUP_CATEGORIZATION,
        nextStepName: MaltClassicCreationStepName.SIGNUP_INDUSTRY_EXPERTISE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: MaltClassicExpertiseStep,
    },
    {
        name: MaltClassicCreationStepName.SIGNUP_INDUSTRY_EXPERTISE,
        route: MaltClassicCreationStepRoute.SIGNUP_INDUSTRY_EXPERTISE,
        stepNumber: MaltClassicCreationStepNumber.SIGNUP_INDUSTRY_EXPERTISE,
        stepCount: totalStep,
        stepPercentage: MaltClassicCreationStepPercentage.SIGNUP_INDUSTRY_EXPERTISE,
        previousStepName: MaltClassicCreationStepName.SIGNUP_EXPERTISE,
        nextStepName: MaltClassicCreationStepName.SIGNUP_DAILY_RATE,
        group: ProfileCreationStepGroup.SIGNUP,
        component: IndustryExpertiseStep,
    },
    {
        name: MaltClassicCreationStepName.SIGNUP_DAILY_RATE,
        route: MaltClassicCreationStepRoute.SIGNUP_DAILY_RATE,
        stepNumber: MaltClassicCreationStepNumber.SIGNUP_DAILY_RATE,
        stepCount: totalStep,
        stepPercentage: MaltClassicCreationStepPercentage.SIGNUP_DAILY_RATE,
        previousStepName: MaltClassicCreationStepName.SIGNUP_INDUSTRY_EXPERTISE,
        nextStepName: MaltClassicCreationStepName.SIGNUP_LOCALISATION,
        group: ProfileCreationStepGroup.SIGNUP,
        component: DailyRateStep,
    },
    {
        name: MaltClassicCreationStepName.SIGNUP_LOCALISATION,
        route: MaltClassicCreationStepRoute.SIGNUP_LOCALISATION,
        stepNumber: MaltClassicCreationStepNumber.SIGNUP_LOCALISATION,
        stepCount: totalStep,
        stepPercentage: MaltClassicCreationStepPercentage.SIGNUP_LOCALISATION,
        previousStepName: MaltClassicCreationStepName.SIGNUP_DAILY_RATE,
        nextStepName: MaltClassicCreationStepName.COMPLETION_DESCRIPTION, // signup
        group: ProfileCreationStepGroup.SIGNUP,
        component: LocalisationDetails,
    },
    {
        name: MaltClassicCreationStepName.COMPLETION_DESCRIPTION,
        route: MaltClassicCreationStepRoute.COMPLETION_DESCRIPTION,
        stepNumber: MaltClassicCreationStepNumber.COMPLETION_DESCRIPTION,
        stepCount: totalStep,
        stepPercentage: MaltClassicCreationStepPercentage.COMPLETION_DESCRIPTION,
        previousStepName: null, // signup
        nextStepName: MaltClassicCreationStepName.COMPLETION_RECOMMENDATION,
        group: ProfileCreationStepGroup.COMPLETION,
        component: DescriptionStep,
    },
    {
        name: MaltClassicCreationStepName.COMPLETION_RECOMMENDATION,
        route: MaltClassicCreationStepRoute.COMPLETION_RECOMMENDATION,
        stepNumber: MaltClassicCreationStepNumber.COMPLETION_RECOMMENDATION,
        stepCount: totalStep,
        stepPercentage: MaltClassicCreationStepPercentage.COMPLETION_RECOMMENDATION,
        previousStepName: MaltClassicCreationStepName.COMPLETION_DESCRIPTION,
        nextStepName: MaltClassicCreationStepName.COMPLETION_PRIVACY,
        group: ProfileCreationStepGroup.COMPLETION,
        component: RecommendationStep,
    },
    {
        name: MaltClassicCreationStepName.COMPLETION_PRIVACY,
        route: MaltClassicCreationStepRoute.COMPLETION_PRIVACY,
        stepNumber: MaltClassicCreationStepNumber.COMPLETION_PRIVACY,
        stepCount: totalStep,
        stepPercentage: MaltClassicCreationStepPercentage.COMPLETION_PRIVACY,
        previousStepName: MaltClassicCreationStepName.COMPLETION_RECOMMENDATION,
        nextStepName: null, // profile page
        group: ProfileCreationStepGroup.COMPLETION,
        component: PrivacyStep,
    },
];
